// cSpell:enableCompoundWords
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoaderType } from 'components/asloader/ASLoader';
import { RootState } from 'slices/store';
import { ASComponentSize } from 'types/App.types';
import { TabPanel } from 'types/SqGame.types';

type LoaderDetails = {
  visible: boolean;
  size?: ASComponentSize;
  type?: LoaderType;
};

export type AppUiProps = {
  loader: LoaderDetails;
  activePanel: string;
  screenTitle: string;
  activeTab: TabPanel;
};

const initialState: AppUiProps = {
  loader: {
    visible: false,
    size: ASComponentSize.Large,
    type: LoaderType.Grow,
  },
  screenTitle: 'Squares',
  activeTab: TabPanel.None,
  activePanel: '',
};

export const appUiSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setShowLoader: (state, action: PayloadAction<LoaderDetails>) => {
      state.loader = { ...state.loader, ...action.payload };
    },
    setScreenTitle: (state, action: PayloadAction<string>) => {
      state.screenTitle = action.payload;
    },
    setActiveTab: (state, action: PayloadAction<TabPanel>) => {
      state.activeTab = action.payload;
    },

    resetAppUi: () => {
      return { ...initialState };
    },
  },
});

export const { setShowLoader, setActiveTab, setScreenTitle, resetAppUi } = appUiSlice.actions;

export const getLoader = (state: RootState): LoaderDetails => state.ui.app.loader;
export const getShowLoader = (state: RootState): boolean => state.ui.app.loader.visible;
export const getScreenTitle = (state: RootState): string => state.ui.app.screenTitle;
export const getActiveTab = (state: RootState): TabPanel => state.ui.app.activeTab;

export default appUiSlice.reducer;
